// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1O1Wv","content":"styles_content__3QTQQ","checkbox":"styles_checkbox__2lD2G","checkboxLabel":"styles_checkboxLabel__2U8PA"};